import {WORKFORCE_HISTORY_LABELS} from '@/utils/employeeWorkforceHistory';

export const EMPLOYEE_HISTORY_EVENT_LABELS = Object.freeze({
    ...WORKFORCE_HISTORY_LABELS,
    assignment_changed: 'Распределение изменено',
    assignment_cancelled: 'Перемещение отменено',
    assignment_cancelled_due_lifecycle: 'Будущая расстановка отменена',
    assignment_reset_on_reserve: 'Расстановка закрыта при переводе в резерв',
    planned_move_created: 'Запланировано перемещение',
    planned_move_confirmed: 'Подтверждено прибытие',
    planned_move_cancelled: 'Плановое перемещение отменено',
    workforce_plan_range_changed: 'Изменён диапазон плана',
    object_assignment_added: 'Добавлен дополнительный объект',
    object_assignment_ended: 'Дополнительное назначение завершено',
    characteristic_added: 'Добавлена характеристика',
    characteristic_updated: 'Характеристика изменена',
    characteristic_voided: 'Характеристика отменена',
    characteristic_pinned: 'Характеристика закреплена',
    characteristic_unpinned: 'Характеристика откреплена',
    absence_started: 'Добавлено временное отсутствие',
    absence_ended: 'Завершено временное отсутствие',
    absence_updated: 'Временное отсутствие изменено',
    absence_voided: 'Отсутствие отменено',
    reserve_returned: 'Возврат из резерва',
    lifecycle_status_changed: 'Изменён статус трудовых отношений',
    employee_termination_scheduled: 'Запланировано увольнение',
    employee_termination_rescheduled: 'Изменено запланированное увольнение',
    employee_termination_cancelled: 'Запланированное увольнение отменено',
    employee_termination_completed: 'Увольнение выполнено',
    employee_updated: 'Изменена карточка сотрудника',
    hiring_form_changed: 'Изменена форма найма',
    employee_created: 'Создана карточка сотрудника',
    employee_cards_merged: 'Объединены карточки сотрудника',
    skill_created: 'Добавлен навык',
    skill_updated: 'Изменён навык',
    skill_deleted: 'Удалён навык',
    employment_period_created: 'Добавлен период занятости',
    employment_period_updated: 'Изменён период занятости',
    employment_period_deleted: 'Удалён период занятости',
    employment_period_ended: 'Завершён период занятости',
    employment_period_started: 'Начат период занятости',
    one_c_import_created: 'Карточка создана при импорте из 1С',
    one_c_import_updated: 'Карточка дополнена данными из 1С',
    employee_created_from_argus_user: 'Создана карточка для учётной записи',
    argus_user_linked: 'Привязана учётная запись Аргуса',
    argus_user_synchronized: 'Сверены данные учётной записи',
    google_workforce_imported: 'Перенесены данные из Google-таблицы',
    imported: 'Импортированы данные сотрудника'
});

const EMPLOYEE_SOURCE_LABELS = Object.freeze({
    timesheet_roster: 'Состав табеля',
    argus: 'Аргус',
    user_account: 'Учётная запись',
    manual: 'Вручную',
    google_contacts: 'Google',
    google_contacts_confirmation: 'Подтверждение при импорте Google',
    google_sheets: 'Google Таблицы',
    google_workforce: 'Google-таблица кадровиков',
    '1c_zup': '1С',
    employee_merge: 'Сверка дублей',
    argus_account_confirmation: 'Подтверждение при создании учётной записи',
    system: 'Система'
});

export function employeeHistoryEventLabel(event) {
    if (event && event.source === 'timesheet_roster') return event.changes && event.changes.timesheet_roster_action === 'restored'
        ? 'Возвращён в табель' : 'Убран из табеля';
    const type = event && event.event_type;
    if (type === 'employee_workforce_visibility_changed') {
        const changes = event.changes || {};
        const before = changes.old || {};
        const after = changes.new || {};
        if (before.effective_hidden !== after.effective_hidden) {
            return after.effective_hidden
                ? (changes.view === 'board' ? 'Скрыт на доске' : 'Скрыт в плане')
                : (changes.view === 'board' ? 'Возвращён на доску' : 'Возвращён в план');
        }
        return `Изменена настройка отображения: ${changes.view === 'board' ? 'доска' : 'план'}`;
    }
    return EMPLOYEE_HISTORY_EVENT_LABELS[type] || 'Изменение сотрудника';
}

export function employeeHistoryTimestamp(event) {
    return event && (event.recorded_at || event.createdAt || event.occurred_at);
}

export function employeeHistoryReasonLabel(event) {
    if (event && event.source === 'timesheet_roster') return event.changes && event.changes.timesheet_roster_action === 'restored'
        ? 'Причина предыдущего исключения из табеля' : 'Причина исключения из табеля';
    const type = String(event && event.event_type || '');
    return type.indexOf('employee_termination_') === 0
        || type === 'lifecycle_status_changed' && ((event.changes || {}).lifecycle_status || {}).new === 'reserve'
            && ['manual_termination', 'scheduled_termination', '1c_zup'].includes(event.source)
        ? 'Причина увольнения' : 'Причина';
}

export function employeeHistoryActorLabel(event, fallback = 'Система') {
    if (event && event.actor_name) return event.actor_name;
    return event && event.actor_user_id
        ? `Пользователь #${event.actor_user_id}`
        : fallback;
}

export function employeeSourceLabel(source) {
    return EMPLOYEE_SOURCE_LABELS[source]
        || source
        || 'Источник не указан';
}

export function formatEmployeeHistoryDateTime(value, emptyLabel = '') {
    if (!value) return emptyLabel;
    const date = new Date(value);
    return Number.isNaN(date.getTime())
        ? String(value)
        : date.toLocaleString('ru-RU');
}
